/**
 * 📌 作用：
 *
 * 作用类似于 Vue 组件中的 computed 计算属性
 * 用来对 state 进行计算、过滤、拼接
 * 不会修改 state，只是用于获取数据
 * ✅ 如何使用 getters？
 * computed: {
 *   userId() {
 *     return this.$store.getters.getUserId;
 *   },
 * }
 */
export default {
  //新增或者已整理的
  getUserId(state) {
    return state.userId || Number(localStorage.getItem('userId')) || 0;
  },

  //未整理的

  // nfcReadTxt(state) {
  //   return state.nfcReadTxt
  // },
  // nfcWriteTxt: state => {
  //   return state.nfcWriteTxt
  // },
  getShowPublish(state) {
    return state.showPublish
  },
  getIsCart(state) {
    return state.isCart
  },
  getOrderObj(state) {
    return state.orderStateObj
  },
  getTalkbaoIndex(state) {
    return state.talkbaoindex
  },
  getGuangguangIndex(state) {
    return state.guangguangindex
  },
  getImprintIndex(state) {
    return state.imprintindex
  },
  getShowUpdateNum(state) {
    return state.showUpdateNum
  },
  getFocusAddRemark(state) {
    return state.focusAddRemark
  },
  getUserInfo(state) {
    if (!state) {
      let localUser = localStorage.getItem('userinfo')
      if (localUser) {
        return localUser
      }
    }
    return state
  },

  getBoothStoreDetail(state) {
    return state.boothStoreDetail
  },
  getOrderKeyId(state) {
    return state.orderKeyId
  },
  getIGetSalesNum(state) {
    return state.iGetSalesNum
  },
  getIGetUpdateSalesNum(state) {
    return state.iGetUpdateSalesNum
  },
  getBmTab(state) {
    return state.bmTab
  },
  getBackWaitOrder(state) {
    return state.backWaitOrder
  },
  getAddRemarkText(state) {
    return state.addRemarkText
  },
  getAddRemarkObj(state) {
    return state.addRemarkObj
  },
  getVideoShow(state) {
    return state.videoShow
  },
  getVideoSrc(state) {
    return state.videoSrc
  },
  getHomePop(state) {
    return state.homePop
  },
  nfcReadtxt: state => {
    return state.nfcReadTxt
  },
  nfcWriteTxt: state => {
    return state.nfcWriteTxt
  },

  nfcWriteLog: state => {
    return state.nfcWriteLog
  },
  // getNum(state){
  //   state.swiperNum = JSON.parse(localStorage.getItem('swiperNum'))
  //   console.log('113231',state.swiperNum);
  //   return state.swiperNum
  // }

  //NFC
  readMode: (state) => state.readMode,
  writeMode: (state) => state.writeMode,
  isProcessing: (state) => state.isProcessing,
  multipleWrite: (state) => state.multipleWrite,
  getResourceId: (state) => state.resourceId,
  getRedirectTo: (state) => state.redirectTo,

  getIsApp: (state) => state.isApp,
  getIsWechat: (state) => state.isWechat,
  getPayInfo: (state) => state.payInfo,
  getAppType: (state) => state.appType,
  getShopCardNum: (state) => state.shopCartNum,

  // 订单数据
  getOrderData: (state) => state.orderData,

  // 权限管理
  getPermissions: (state) => {
    // 如果state中没有权限数据，尝试从localStorage获取
    if (!state.permissions || state.permissions.length === 0) {
      const localPermissions = localStorage.getItem('userPermissions');
      if (localPermissions) {
        try {
          return JSON.parse(localPermissions);
        } catch (e) {
          console.error('解析权限数据失败:', e);
          return [];
        }
      }
    }
    return state.permissions || [];
  },

  // 判断是否有某个权限
  hasPermission: (state, getters) => (code) => {
    const permissions = getters.getPermissions;
    return permissions.includes(code);
  },

  // 批量判断权限
  hasPermissions: (state, getters) => (codes) => {
    const permissions = getters.getPermissions;
    return codes.every(code => permissions.includes(code));
  },

  // 判断是否有某个权限分类中的任意权限
  hasAnyPermission: (state, getters) => (codes) => {
    const permissions = getters.getPermissions;
    return codes.some(code => permissions.includes(code));
  },

  // 获取商品库存筛选状态
  getProductStockFilter: state => {
    return state.productStockFilter || 'all';
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js